<template>
  <div
    class="flex flex-col py-2 px-3 cursor-pointer w-full overflow-x"
    @click="click"
  >
    <span class="text-xs font-semibold mb-1 text-justify">{{ subject }}</span>
    <span
      class="text-xs secondary_color break-all line-clamp-6 overflow-hidden"
    >
      {{ getTextFromHtml(message) }}
    </span>
    <span class="mt-1 text-xs" v-if="sequence">
      <span class="font-semibold text_color" v-if="sequence.name">
        {{ sequence.step }} of
      </span>
      <span class="font-semibold text_color" v-if="sequence.step">
        {{ sequence.name }}
      </span>
    </span>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
import { getTextFromHtml } from "@/src/utils/htmlUtils.js";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const { message, subject, sequence } = props.value;

const click = () => {
  eventBus.emit("emails/showActivity", props.row);
};
</script>
